import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DescriptedLabel, Input } from 'iebt-zing-storybook'
import React, { useEffect, useState } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Image from 'react-bootstrap/Image'
import { useSelector } from 'react-redux'
import { trans } from 'sharedKernel/i18n'
import { showToast } from 'components/toast'
import { store, TReducers } from 'store'
import { FormTitle, SectionTitle } from '../styles'
import {
  DROPDOWN_BRAZIL_STATES,
  INPUT_MASK_FORMAT,
  DROPDOWN_COUNTRIES,
  DROPDOWN_ACTIVITY,
  DROPDOWN_BUSINESS_MODEL,
  DROPDOWN_NUMBER_EMPLOYEES,
  RESOLVER_INVESTMENTE_SOURCE,
  DROPDOWN_DEVELOPMENT_STAGE,
  DROPDOWN_TARGET_MODEL,
  getPhoneMask
} from 'sharedKernel/constants'
import { updateConfigForm } from './store/configForm'
import { IProfileImage, updateProfileImage } from './store/profileImage'
import {
  handlePhoneValidity,
  ifNotEmptyValidateCEP,
  isEmptyField,
  setInvalid
} from 'domain/feature/hotsite/Forms/validations'
import { getAddressByZIP } from 'sharedKernel/api/utils/cep'
import { IViaCepServiceAddressResponse } from 'sharedKernel/api/utils/cep/contract'
import { applyMaskIfNotEmpty, applyTitleOnError } from 'sharedKernel/handlers'
import { regexPatterns } from 'sharedKernel/regex'
import { handleUserConfigFormValidity, isPhoneOrMobileFilled, isResolverUser } from './behavior/validation'
import { IFormFieldProperties } from 'domain/feature/hotsite/Forms/contracts'
import { LabelInputFile } from 'sharedKernel/styledComponents/fileComponents/styles'
import { showModal } from 'components/popup'
import { caixaUser } from 'sharedKernel/user/CaixaUser'
import { loggedUser } from 'sharedKernel/user/LoggedUser'
import { getCredLocalStorage } from 'sharedKernel/auth/credLocalStorage'
import { LabeledCheckbox } from 'components/LabeledCheckbox'
import { FormItem } from '../../company/challenge/FormWrapper/style'

export const PersonalConfigForm = (): JSX.Element => {
  const userConfigFormState = useSelector((state: TReducers) => state.hubIUserConfigFormState)
  const profileImage = useSelector((state: TReducers) => state.hubIProfileImage)
  const userPermissions = useSelector((state: TReducers) => state.auth.permissions)
  const [isResolver, setIsResolver] = useState<boolean>(false)
  const origin = userConfigFormState.investmentOrigin?.value ?? ''
  const validSources = RESOLVER_INVESTMENTE_SOURCE.map(o => o.value)
  const selectValue = validSources.includes(origin) ? origin : 'Outro'
  const [isOtherOrigin, setIsOtherOrigin] = useState<boolean>(false)
  const user = loggedUser.get()
  const isCaixaEmployee = caixaUser.isCaixaUser() || user?.role?.name === 'CaixaEmployee'
  const companyType = getCredLocalStorage()?.company?.type?.type;

  const labels = {
    name: trans('Nome completo'),
    phone: trans('Número para contato'),
    mobile: trans('Insira seu celular'),
    zipcode: trans('Insira seu CEP'),
    lineOne: trans('Insira seu endereço'),
    number: trans('Insira seu numero'),
    lineTwo: trans('Insira seu complemento'),
    city: trans('Insira sua cidade'),
    state: trans('Insira seu estado'),
    fileSize: trans('Cada arquivo deve ter um tamanho máximo de 5 MB'),
    profileImage: trans('Adicionar'),
    invalidNotFoundCEP: trans('CEP inválido ou não encontrado'),
    titleMessage: trans('Preencha este campo'),
    country: trans('País'),
    caixaRole: trans('Cargo/Função'),
    caixaRolePlaceholder: trans('Insira seu cargo/função'),
    caixaDepartment: trans('Código da Unidade'),
    caixaDepartmentPlaceholder: trans('Insira o código da unidade'),
    caixaEducation: trans('Formação acadêmica principal'),
    caixaEducationPlaceholder: trans('Insira sua formação acadêmica principal'),
    caixaMatricula: trans('Matrícula'),
    caixaMatriculaPlaceholder: trans('Insira apenas números (ex: 123456)'),
    activity: trans('Qual é a Vertical/Setor de atuação?'),
    annualRevenue: trans('Insira o faturamento anual'),
    site: trans('Insira o site da startup/projeto'),
    cnpj: trans('Digite o CNPJ'),
    contactName: trans('Insira o nome do responsável'),
    neighborhood: trans('Insira o nome do bairro'),
    target: trans('Público Alvo'),
    ecosystemTermsAgreement: trans('Autorizo minha participação no '),
    ecosystemTermsLink: trans('ecossistema de inovação do IEBT Innovation'),
    ecosystemTerms: trans(', por meio da plataforma Zing.'),
    ecosystemTermsTitle: trans('Ecossistema de Inovação IEBT Innovation'),
    failureGetEcosystemTerms: trans('Termos de uso indisponível, tente novamente mais tarde.'),
    firstParagraph: trans('Pelo presente Termo, a empresa abaixo identificada, doravante denominada "STARTUP", declara ter lido, compreendido e aceitado os termos aqui descritos, consentindo com a inclusão de seus dados no Ecossistema da Plataforma Zing, mantida pelo IEBT Innovation, CNPJ nº 11.053.814/0001-00, com sede na Rua Professor José Vieira de Mendonça, nº 770, sala 408 - Engenho Nogueira, Belo Horizonte/MG.'),
    firstTitle: trans('1. OBJETIVO'),
    secondParagraph: trans('A STARTUP autoriza a coleta, uso e divulgação de seus dados pela Plataforma Zing com o objetivo de promover conexões com investidores, empresas e demais agentes do ecossistema de inovação.'),
    secondTitle: trans('2. DADOS QUE PODERÃO SER DIVULGADOS'),
    thirdParagraph: trans('Estágio de desenvolvimento; Faturamento; Histórico de captação; Vertical ou setor de atuação; Modelo de negócio; Número de colaboradores; Tecnologias utilizadas; Descrição para pitch; E-mail, telefone e endereço comercial.'),
    thirdTitle: trans('3. USO DAS INFORMAÇÕES'),
    fourthParagraph: trans('Os dados poderão ser publicados na plataforma, compartilhados com parceiros estratégicos e utilizados em relatórios e comunicações do ecossistema, sempre respeitando a finalidade de promoção da starup.'),
    fourthTitle: trans('4. PRIVACIDADE E DADOS PESSOAIS'),
    fifthParagraph: trans('A Plataforma Zing seguirá as diretrizes da LGPD. Dados pessoais só serão usados com finalidade legítima e consentimento claro. A STARTUP pode solicitar a alteração ou remoção de dados a qualquer momento.'),
    fifthTitle: trans('5. VIGÊNCIA'),
    sixthParagraph: trans('O consentimento é válido enquanto a STARTUP desejar permanecer no ecossistema. A exclusão pode ser solicitada a qualquer momento por e-mail.'),
    sixthTitle: trans('6. DISPOSIÇÕES FINAIS'),
    seventhParagraph: trans('Esse termo não gera vínculo contratual, societário ou transferência de propriedade intelectual. O foro de Belo Horizonte/MG fica eleito para eventuais questões legais.')
  }

  const [previewFile, setPreview] = useState<any>(profileImage.path)
  const noImage = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'

  const handleChange = (value, key): void => {
    userConfigFormState[key].value = value
    store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
  }

  useEffect(() => {
    if (profileImage != null) {
      setPreview(profileImage.path)
    } else {
      setPreview(noImage)
    }
  }, [profileImage])

  useEffect(() => {
    setIsResolver(isResolverUser(userPermissions))
  }, [userPermissions])

  useEffect(() => {
    if (selectValue === 'Outro') {
      setIsOtherOrigin(true)
    }
  }, [selectValue])

  const handleZIPActions = async (zipcode: IFormFieldProperties): Promise<void> => {
    if (ifNotEmptyValidateCEP(zipcode)) {
      await autoFillAddressByZIP(userConfigFormState.zipcode.value.replace(regexPatterns.clearMaskedNumbers, ''))
    }
  }

  const autoFillAddressByZIP = async (zipcode: string): Promise<void> => {
    await getAddressByZIP(zipcode)
      .then((response) => {
        fillAddress(response)
      })
      .catch((error) => {
        showToast('error', error)
        setInvalid(userConfigFormState.zipcode, labels.invalidNotFoundCEP)
        store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
      })
  }

  const fillAddress = (address: IViaCepServiceAddressResponse): void => {
    handleChange(address.uf, 'state')
    handleChange(address.logradouro, 'lineOne')
    handleChange(address.localidade, 'city')
    handleChange(address.bairro, 'neighborhood')
  }

  const getEcosystemTermsContent = (): JSX.Element => {
    return (
      <div>
        <p>{labels.firstParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.firstTitle}</h6>
        <p>{labels.secondParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.secondTitle}</h6>
        <p>{labels.thirdParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.thirdTitle}</h6>
        <p>{labels.fourthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.fourthTitle}</h6>
        <p>{labels.fifthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.fifthTitle}</h6>
        <p>{labels.sixthParagraph}</p>
        <h6 style={{ marginBottom: '1rem', marginTop: '2rem', fontWeight: 'bold' }}>{labels.sixthTitle}</h6>
        <p>{labels.seventhParagraph}</p>
      </div>
    )
  }

  const renderEcosystemTermsModal = (): void => {
    showModal('single', {
      title: labels.ecosystemTermsTitle,
      message: getEcosystemTermsContent()
    })
  }
  
  return (
    <>
      <FormTitle>
        <h1>Configurações pessoais</h1>
        <hr />
      </FormTitle>

      <div style={{ 
        backgroundColor: '#ffffff', 
        borderRadius: '8px', 
        padding: '24px',
        marginBottom: '32px'
      }}>
        <SectionTitle>Informações gerais</SectionTitle>
        <Row>
        <Col style={{ margin: '10px 0 30px 0' }} sm={12} className="d-flex flex-row gap-4">
          {/* Imagem de perfil */}
          <div>
            <Image
              style={{
                objectFit: 'cover',
                border: '1px solid #ccc',
                backgroundColor: '#f1f1f1'
              }}
              src={previewFile}
              rounded
              width={90}
              height={90}
            />
          </div>

          {/* Bloco com label, botão e instruções */}
          <div className="d-flex flex-column">

            <span style={{ fontWeight: 'bold', marginBottom: 4 }}>Logo</span>

            <LabelInputFile
              style={{
                backgroundColor: '#ede5ff',
                color: 'var(--primary)',
                fontWeight: 700,
                padding: '6px 12px',
                borderRadius: '6px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '0.875rem',
                width: 'auto',
                maxWidth: '160px',
                whiteSpace: 'nowrap',
                textAlign: 'center',
                textDecoration: 'none'
              }}
              isClickable
            >
              <FontAwesomeIcon className="pr-2" icon={['fas', 'cloud-upload-alt']} style={{ color: 'var(--primary)' }} />
              {labels.profileImage}
              <input
                type="file"
                accept="image/*"
                onChange={(event) => {
                  const files = event.target.files ?? []
                  const file = files[0]

                  if (file.size > 5242880) {
                    showToast('warning', trans(labels.fileSize))
                    return
                  }

                  const selectedFile: IProfileImage = {
                    path: URL.createObjectURL(file),
                    isDeleted: false,
                    name: file.name.replace(/ /g, '_'),
                    size: file.size,
                    mimetype: file.type,
                    extension: null,
                    type: 'profileImage',
                    content: null,
                    sourceFile: file
                  }
                  store.dispatch(updateProfileImage(selectedFile))
                }}
              />
            </LabelInputFile>

            <span className="text-muted mt-2" style={{ fontSize: '0.75rem' }}>
              Dimensão recomendada: 500 × 600 px
              <br />
              Tamanho máximo: 5 MB
            </span>
          </div>
        </Col>
        {/* Nome completo */}
        <Col sm={12}>
          <Input
            label="Nome completo"
            value={userConfigFormState.name?.value}
            isRequired={userConfigFormState.name?.isRequired}
            title={applyTitleOnError(userConfigFormState.name?.message, labels.titleMessage)}
            isInvalid={userConfigFormState.name?.isInvalid}
            notValidFieldMessage={userConfigFormState.name?.message}
            placeholder={labels.name}
            code="masked"
            maxLength={60}
            onChange={(event) => {
              handleChange(event.target.value, 'name')
              isEmptyField(userConfigFormState.name)
              store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
            }}
          ></Input>
        </Col>
        
        {!isCaixaEmployee && (
          <Col sm={12}>
            <Input
              label="E-mail"
              value={userConfigFormState.email?.value || ''}
              isRequired={false}
              disabled
              title={applyTitleOnError(userConfigFormState.email?.message || '', labels.titleMessage)}
              isInvalid={userConfigFormState.email?.isInvalid}
              notValidFieldMessage={userConfigFormState.email?.message}
              placeholder="Insira seu e-mail"
              onChange={(event) => {
                handleChange(event.target.value, 'email')
                if (userConfigFormState.email) {
                  isEmptyField(userConfigFormState.email)
                }
                store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
              }}
            />
          </Col>
        )}

        {companyType === 'City Hall' && (
          <>
            <Col sm={6}>
              <Input
                label={labels.phone}
                isInvalid={userConfigFormState.phone?.isInvalid}
                notValidFieldMessage={userConfigFormState.phone?.message}
                value={userConfigFormState.phone?.value}
                isRequired={userConfigFormState.phone?.isRequired}
                title={applyTitleOnError(userConfigFormState.phone?.message, labels.titleMessage)}
                placeholder={labels.phone}
                code="masked"
                mask={applyMaskIfNotEmpty(
                  userConfigFormState.phone?.value,
                  getPhoneMask(userConfigFormState.phone?.value)
                )}
                onChange={(event) => {
                  handleChange(event.target.value, 'phone')
                  if (isPhoneOrMobileFilled(userConfigFormState)) {
                    handlePhoneValidity(userConfigFormState.phone)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
          </>
        )}

        {companyType === 'Admin City Hall' && (
          <>
            <Col sm={6}>
              <Input
                label={labels.phone}
                isInvalid={userConfigFormState.phone?.isInvalid}
                notValidFieldMessage={userConfigFormState.phone?.message}
                value={userConfigFormState.phone?.value}
                isRequired={userConfigFormState.phone?.isRequired}
                title={applyTitleOnError(userConfigFormState.phone?.message, labels.titleMessage)}
                placeholder={labels.phone}
                code="masked"
                mask={applyMaskIfNotEmpty(
                  userConfigFormState.phone?.value,
                  getPhoneMask(userConfigFormState.phone?.value)
                )}
                onChange={(event) => {
                  handleChange(event.target.value, 'phone')
                  if (isPhoneOrMobileFilled(userConfigFormState)) {
                    handlePhoneValidity(userConfigFormState.phone)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <Col sm={6}>
              <Input
                label="Nome da Prefeitura"
                value={userConfigFormState.cityHallName?.value || ''}
                isRequired={true}
                title={applyTitleOnError(userConfigFormState.cityHallName?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.cityHallName?.isInvalid}
                notValidFieldMessage={userConfigFormState.cityHallName?.message}
                onChange={(event) => {
                  handleChange(event.target.value, 'cityHallName')
                  if (userConfigFormState.cityHallName) {
                    isEmptyField(userConfigFormState.cityHallName)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <Col sm={6}>
              <Input
                label="Nome do Prefeito(a)"
                value={userConfigFormState.mayorName?.value || ''}
                isRequired={true}
                title={applyTitleOnError(userConfigFormState.mayorName?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.mayorName?.isInvalid}
                notValidFieldMessage={userConfigFormState.mayorName?.message}
                onChange={(event) => {
                  handleChange(event.target.value, 'mayorName')
                  if (userConfigFormState.mayorName) {
                    isEmptyField(userConfigFormState.mayorName)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <Col sm={6}>
              <Input
                label="Qual o tamanho da equipe envolvida no Programa"
                type='number'
                value={userConfigFormState.teamSize?.value || ''}
                isRequired={true}
                title={applyTitleOnError(userConfigFormState.teamSize?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.teamSize?.isInvalid}
                notValidFieldMessage={userConfigFormState.teamSize?.message}
                onChange={(event) => {
                  const raw = event.target.value;
                  const numeric = Number(raw);

                  if (!raw) {
                    handleChange('', 'teamSize');
                  } else if (!Number.isNaN(numeric)) {
                    const clamped = Math.min(numeric, 5);
                    handleChange(clamped, 'teamSize');
                  }

                  if (userConfigFormState.teamSize) {
                    isEmptyField(userConfigFormState.teamSize);
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)));
                }}
              />
            </Col>
            <Col sm={12} style={{ margin: '30px 0 20px 0' }}>
              <div style={{ 
                borderTop: '1px solid #C4C5C6', 
                paddingTop: '16px'
              }}>
                <h6 style={{ 
                  color: '#6B7280', 
                  fontSize: '14px', 
                  fontWeight: '500',
                  margin: 0,
                  padding: 0
                }}>
                  Sobre a secretaria
                </h6>
              </div>
            </Col>
            <Col sm={12}>
              <FormItem>
                <DescriptedLabel>
                  {'Possui secretária responsável pela agenda de Inovação em seu Muncípio?'}
                </DescriptedLabel>

                <Form.Check
                  onChange={() => {
                    handleChange('true', 'hasSecretary');
                    if (userConfigFormState.hasSecretary) {
                      isEmptyField(userConfigFormState.hasSecretary);
                    }
                    store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)));
                  }}
                  checked={userConfigFormState.hasSecretary?.value === 'true'}
                  label="Sim"
                />

                <Form.Check
                  onChange={() => {
                    handleChange('false', 'hasSecretary');
                    if (userConfigFormState.hasSecretary) {
                      isEmptyField(userConfigFormState.hasSecretary);
                    }
                    store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)));
                  }}
                  checked={userConfigFormState.hasSecretary?.value === 'false'}
                  label="Não"
                />
              </FormItem>
            </Col>
            <Col sm={6}>
              <Input
                label="Nome da Secretária"
                value={userConfigFormState.secretary?.value || ''}
                isRequired={true}
                title={applyTitleOnError(userConfigFormState.secretary?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.secretary?.isInvalid}
                notValidFieldMessage={userConfigFormState.secretary?.message}
                onChange={(event) => {
                  handleChange(event.target.value, 'secretary')
                  if (userConfigFormState.secretary) {
                    isEmptyField(userConfigFormState.secretary)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <Col sm={6}>
              <Input
                label="Nome do responsável pela secretária"
                value={userConfigFormState.secretaryResponsible?.value || ''}
                isRequired={true}
                title={applyTitleOnError(userConfigFormState.secretaryResponsible?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.secretaryResponsible?.isInvalid}
                notValidFieldMessage={userConfigFormState.secretaryResponsible?.message}
                onChange={(event) => {
                  handleChange(event.target.value, 'secretaryResponsible')
                  if (userConfigFormState.secretaryResponsible) {
                    isEmptyField(userConfigFormState.secretaryResponsible)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
          </>
        )}
        
        {/* E-mail institucional e Telefone - apenas para funcionários da Caixa */}
        {isCaixaEmployee && companyType !== 'Admin City Hall' && companyType !== 'City Hall' && (
          <>
            <Col sm={6}>
              <Input
                label="E-mail institucional"
                value={userConfigFormState.email?.value || ''}
                isRequired={true}
                disabled
                title={applyTitleOnError(userConfigFormState.email?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.email?.isInvalid}
                notValidFieldMessage={userConfigFormState.email?.message}
                placeholder="Insira seu e-mail institucional"
                onChange={(event) => {
                  handleChange(event.target.value, 'email')
                  if (userConfigFormState.email) {
                    isEmptyField(userConfigFormState.email)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <Col sm={6}>
              <Input
                label={labels.phone}
                isInvalid={userConfigFormState.phone?.isInvalid}
                notValidFieldMessage={userConfigFormState.phone?.message}
                value={userConfigFormState.phone?.value}
                isRequired={userConfigFormState.phone?.isRequired}
                title={applyTitleOnError(userConfigFormState.phone?.message, labels.titleMessage)}
                placeholder={labels.phone}
                code="masked"
                mask={applyMaskIfNotEmpty(
                  userConfigFormState.phone?.value,
                  getPhoneMask(userConfigFormState.phone?.value)
                )}
                onChange={(event) => {
                  handleChange(event.target.value, 'phone')
                  if (isPhoneOrMobileFilled(userConfigFormState)) {
                    handlePhoneValidity(userConfigFormState.phone)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
          </>
        )}
        {/* Campos de  - apenas para usuários que NÃO são funcionários da Caixa */}
        {!isCaixaEmployee && companyType !== 'Admin City Hall' && companyType !== 'City Hall' && (
          <>
            <Col sm={12} style={{ margin: '30px 0 20px 0' }}>
              <div style={{ 
                borderTop: '1px solid #C4C5C6', 
                paddingTop: '16px',
                marginBottom: '20px'
              }}>
                <h6 style={{ 
                  color: '#6B7280', 
                  fontSize: '14px', 
                  fontWeight: '500',
                  margin: 0,
                  padding: 0
                }}>
                  Informações da Empresa
                </h6>
              </div>
            </Col>
            
            <Col sm={6}>
              <Input
                label="CNPJ"
                isInvalid={userConfigFormState.cnpj?.isInvalid}
                notValidFieldMessage={userConfigFormState.cnpj?.message}
                value={userConfigFormState.cnpj?.value}
                isRequired={userConfigFormState.cnpj?.isRequired}
                title={applyTitleOnError(userConfigFormState.cnpj?.message, labels.titleMessage)}
                placeholder={labels.cnpj}
                code="masked"
                mask={applyMaskIfNotEmpty(userConfigFormState.cnpj?.value, INPUT_MASK_FORMAT.CNPJ)}
                onChange={(event) => {
                  handleChange(event.target.value, 'cnpj')
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            
            <Col sm={6}>
              <Input
                label="Nome do Responsável"
                isInvalid={userConfigFormState.contactName?.isInvalid}
                notValidFieldMessage={userConfigFormState.contactName?.message}
                value={userConfigFormState.contactName?.value}
                isRequired={userConfigFormState.contactName?.isRequired}
                title={applyTitleOnError(userConfigFormState.contactName?.message, labels.titleMessage)}
                placeholder={labels.contactName}
                code="masked"
                maxLength={60}
                onChange={(event) => {
                  handleChange(event.target.value, 'contactName')
                  isEmptyField(userConfigFormState.contactName)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            
            <Col sm={12}>
              <Input
                label={labels.phone}
                isInvalid={userConfigFormState.phone?.isInvalid}
                notValidFieldMessage={userConfigFormState.phone?.message}
                value={userConfigFormState.phone?.value}
                isRequired={userConfigFormState.phone?.isRequired}
                title={applyTitleOnError(userConfigFormState.phone?.message, labels.titleMessage)}
                placeholder={labels.phone}
                code="masked"
                mask={applyMaskIfNotEmpty(
                  userConfigFormState.phone?.value || '',
                  getPhoneMask(userConfigFormState.phone?.value || '')
                )}
                onChange={(event) => {
                  handleChange(event.target.value, 'phone')
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            
            {isResolver && (
              <Col sm={12}>
                <Input
                  label="Site da Startup/Projeto"
                  isInvalid={userConfigFormState.site?.isInvalid}
                  notValidFieldMessage={userConfigFormState.site?.message}
                  value={userConfigFormState.site?.value}
                  isRequired={userConfigFormState.site?.isRequired}
                  title={applyTitleOnError(userConfigFormState.site?.message, labels.titleMessage)}
                  placeholder={labels.site}
                  code="masked"
                  maxLength={200}
                  onChange={(event) => {
                    handleChange(event.target.value, 'site')
                    store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                  }}
                />
              </Col>
            )}
            
            <Col sm={12} style={{ margin: '30px 0 20px 0' }}>
              <div style={{ 
                borderTop: '1px solid #C4C5C6', 
                paddingTop: '16px',
                marginBottom: '20px'
              }}>
                <h6 style={{ 
                  color: '#6B7280', 
                  fontSize: '14px', 
                  fontWeight: '500',
                  margin: 0,
                  padding: 0
                }}>
                  Endereço
                </h6>
              </div>
            </Col>
            <Col sm={6}>
              <Input
                label="CEP"
                isInvalid={userConfigFormState.zipcode?.isInvalid}
                notValidFieldMessage={userConfigFormState.zipcode?.message}
                value={userConfigFormState.zipcode?.value}
                isRequired={userConfigFormState.zipcode?.isRequired}
                title={applyTitleOnError(userConfigFormState.zipcode?.message, labels.titleMessage)}
                placeholder={labels.zipcode}
                code="masked"
                mask={applyMaskIfNotEmpty(userConfigFormState.zipcode?.value, INPUT_MASK_FORMAT.CEP)}
                onChange={(event) => {
                  handleChange(event.target.value, 'zipcode')
                  handleZIPActions(userConfigFormState?.zipcode)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              ></Input>
            </Col>
            <Col sm={6}>
              <Input
                label="Endereço"
                isInvalid={userConfigFormState.lineOne?.isInvalid}
                notValidFieldMessage={userConfigFormState.lineOne?.message}
                value={userConfigFormState.lineOne?.value}
                isRequired={userConfigFormState.lineOne?.isRequired}
                placeholder={labels.lineOne}
                maxLength={100}
                code="masked"
                onChange={(event) => {
                  handleChange(event.target.value, 'lineOne')
                }}
              ></Input>
            </Col>
            {/* Número, Complemento e Bairro */}
            <Col sm={4}>
              <Input
                label="Número"
                isInvalid={userConfigFormState.number?.isInvalid}
                notValidFieldMessage={userConfigFormState.number?.message}
                value={userConfigFormState.number?.value}
                isRequired={userConfigFormState.number?.isRequired}
                title={applyTitleOnError(userConfigFormState.number?.message, labels.titleMessage)}
                placeholder={labels.number}
                code="masked"
                maxLength={8}
                onChange={(event) => {
                  handleChange(event.target.value, 'number')
                  isEmptyField(userConfigFormState.number)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              ></Input>
            </Col>
            <Col sm={4}>
              <Input
                label="Complemento"
                isInvalid={userConfigFormState.lineTwo?.isInvalid}
                notValidFieldMessage={userConfigFormState.lineTwo?.message}
                value={userConfigFormState.lineTwo?.value}
                isRequired={userConfigFormState.lineTwo?.isRequired}
                placeholder={labels.lineTwo}
                code="masked"
                maxLength={100}
                onChange={(event) => {
                  handleChange(event.target.value, 'lineTwo')
                }}
              ></Input>
            </Col>
            <Col sm={4}>
              <Input
                label="Bairro"
                isInvalid={userConfigFormState.neighborhood?.isInvalid}
                notValidFieldMessage={userConfigFormState.neighborhood?.message}
                value={userConfigFormState.neighborhood?.value}
                isRequired={userConfigFormState.neighborhood?.isRequired}
                placeholder={labels.neighborhood}
                code="masked"
                maxLength={60}
                onChange={(event) => {
                  handleChange(event.target.value, 'neighborhood')
                }}
              ></Input>
            </Col>
            {/* Cidade, Estado e País */}
            <Col sm={4}>
              <Input
                label="Cidade"
                isInvalid={userConfigFormState.city?.isInvalid}
                notValidFieldMessage={userConfigFormState.city?.message}
                value={userConfigFormState.city?.value}
                isRequired={userConfigFormState.city?.isRequired}
                placeholder={labels.city}
                code="masked"
                maxLength={60}
                onChange={(event) => {
                  handleChange(event.target.value, 'city')
                }}
              ></Input>
            </Col>
            <Col sm={4}>
              <DescriptedLabel>
                {
                  <span style={{ fontWeight: 'bold' }}>
                    {'Estado'}
                    {<span style={{ color: 'red' }}> *</span>}
                  </span>
                }
              </DescriptedLabel>
              <Form.Select
                value={String(userConfigFormState.state?.value)}
                 isInvalid={userConfigFormState.state?.isInvalid}
                onChange={(event) => {
                  handleChange(event.target.value, 'state')
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                 onBlur={() => isEmptyField(userConfigFormState.state)}
              >
                {DROPDOWN_BRAZIL_STATES.map((option, index) => {
                  return (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
            <Col sm={4}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'País'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={String(userConfigFormState.country?.value)}
                title={applyTitleOnError(userConfigFormState.country?.message, labels.titleMessage)}
                isInvalid={userConfigFormState.country?.isInvalid}
                onChange={(event) => {
                  handleChange(event.target.value, 'country')
                  isEmptyField(userConfigFormState.country)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.country)}
              >
                {DROPDOWN_COUNTRIES.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </>
        )}

        {!isCaixaEmployee && isResolver && companyType !== 'Admin City Hall' && companyType !== 'City Hall' && (
          <>
            <SectionTitle>
              Sobre o negócio <hr />
            </SectionTitle>
            {/* Atividade */}
            <Col sm={6} style={{ margin: '0 0 40px' }}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {labels.activity}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={userConfigFormState.activity?.value}
                title={applyTitleOnError(userConfigFormState.activity?.message, labels.titleMessage)}
                isInvalid={userConfigFormState.activity?.isInvalid}
                onChange={(event) => {
                  handleChange(event.target.value, 'activity')
                  isEmptyField(userConfigFormState.activity)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.activity)}
              >
                {DROPDOWN_ACTIVITY.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
              {userConfigFormState.activity?.isInvalid && (
                <div style={{ color: 'red', fontSize: 12 }}>{userConfigFormState.activity?.message}</div>
              )}
            </Col>
            {/* Publico Alvo */}
            <Col sm={6} style={{ margin: '0 0 40px' }}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {labels.target}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={userConfigFormState.target?.value}
                title={applyTitleOnError(userConfigFormState.target?.message, labels.titleMessage)}
                isInvalid={userConfigFormState.target?.isInvalid}
                onChange={(event) => {
                  handleChange(event.target.value, 'target')
                  isEmptyField(userConfigFormState.target)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => {
                  isEmptyField(userConfigFormState.target)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              >
                {DROPDOWN_TARGET_MODEL.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
              {userConfigFormState.target?.isInvalid && (
                <div style={{ color: 'red', fontSize: 12 }}>{userConfigFormState.target?.message}</div>
              )}
            </Col>
            {/* Modelo de Negócio */}
            <Col sm={6}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'Modelo de Negócio'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={String(userConfigFormState.businessModel?.value)}
                isInvalid={userConfigFormState.businessModel?.isInvalid}
                title={applyTitleOnError(userConfigFormState.businessModel?.message, labels.titleMessage)}
                onChange={(event) => {
                  handleChange(event.target.value, 'businessModel')
                  isEmptyField(userConfigFormState.businessModel)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.businessModel)}
              >
                {DROPDOWN_BUSINESS_MODEL.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
              {userConfigFormState.businessModel?.isInvalid && (
                <div style={{ color: 'red', fontSize: 12 }}>{userConfigFormState.businessModel?.message}</div>
              )}
            </Col>
            {/* Número de colaboradores */}
            <Col sm={6} style={{ margin: '0 0 40px' }}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'Número de colaboradores'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={String(userConfigFormState.employees?.value)}
                isInvalid={userConfigFormState.employees?.isInvalid}
                title={applyTitleOnError(userConfigFormState.employees?.message, labels.titleMessage)}
                onChange={(event) => {
                  handleChange(event.target.value, 'employees')
                  isEmptyField(userConfigFormState.employees)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.employees)}
              >
                {DROPDOWN_NUMBER_EMPLOYEES.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
              {userConfigFormState.employees?.isInvalid && (
                <div style={{ color: 'red', fontSize: 12 }}>{userConfigFormState.employees?.message}</div>
              )}
            </Col>
            {/* Quais as tecnologias? */}
            <Col sm={12}>
              <Input
                label="Quais as tecnologias?"
                title={applyTitleOnError(userConfigFormState.technologies?.message, labels.titleMessage)}
                value={userConfigFormState.technologies?.value}
                isRequired={userConfigFormState.technologies?.isRequired}
                isInvalid={userConfigFormState.technologies?.isInvalid}
                notValidFieldMessage={userConfigFormState.technologies?.message}
                code="masked"
                placeholder="Insira as tecnologias utilizadas"
                maxLength={100}
                onChange={(event) => {
                  handleChange(event.target.value, 'technologies')
                  isEmptyField(userConfigFormState.technologies)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            {/* Descrição para pitch? */}
            <Col sm={12}>
              <Input
                label="Descrição para pitch?"
                title={applyTitleOnError(userConfigFormState.pitch?.message, labels.titleMessage)}
                value={userConfigFormState.pitch?.value}
                isRequired={userConfigFormState.pitch?.isRequired}
                isInvalid={userConfigFormState.pitch?.isInvalid}
                notValidFieldMessage={userConfigFormState.pitch?.message}
                placeholder="Insira uma descrição para pitch"
                code="masked"
                maxLength={500}
                onChange={(event) => {
                  handleChange(event.target.value, 'pitch')
                  isEmptyField(userConfigFormState.pitch)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
              />
            </Col>
            <SectionTitle>
              Sobre o desenvolvimento <hr />
            </SectionTitle>
            {/* Qual o estágio do desenvolvimento */}
            <Col sm={6}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'Qual o estágio do desenvolvimento'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                title={applyTitleOnError(userConfigFormState.developmentStage?.message, labels.titleMessage)}
                value={String(userConfigFormState.developmentStage?.value)}
                isInvalid={userConfigFormState.developmentStage?.isInvalid}
                onChange={(event) => {
                  handleChange(event.target.value, 'developmentStage')
                  isEmptyField(userConfigFormState.developmentStage)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.developmentStage)}
              >
                {DROPDOWN_DEVELOPMENT_STAGE.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
              {userConfigFormState.developmentStage?.isInvalid && (
                <div style={{ color: 'red', fontSize: 12 }}>{userConfigFormState.developmentStage?.message}</div>
              )}
            </Col>
            {/* Faturamento anual */}
            <Col sm={6}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'Faturamento anual'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Input
                type="number"
                value={userConfigFormState.annualRevenue?.value}
                isInvalid={userConfigFormState.annualRevenue?.isInvalid}
                isRequired={userConfigFormState.annualRevenue?.isRequired}
                title={applyTitleOnError(userConfigFormState.annualRevenue?.message, labels.titleMessage)}
                notValidFieldMessage={userConfigFormState.annualRevenue?.message}
                code="masked"
                placeholder={labels.annualRevenue}
                onChange={(event) => {
                  handleChange(event.target.value, 'annualRevenue')
                  isEmptyField(userConfigFormState.annualRevenue)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                maxLength={20}
              />
            </Col>
            {/* Já captou investimento? */}
            <Col sm={6}>
              <DescriptedLabel>
                <span style={{ fontWeight: 'bold' }}>
                  {'Já captou investimento?'}
                  <span style={{ color: 'red' }}> *</span>
                </span>
              </DescriptedLabel>
              <Form.Select
                value={String(userConfigFormState.hasRaisedInvestment?.value)}
                title={applyTitleOnError(userConfigFormState.hasRaisedInvestment?.message, labels.titleMessage)}
                isInvalid={userConfigFormState.hasRaisedInvestment?.isInvalid}
                onChange={e => {
                  const v = e.target.value
                  handleChange(v, 'hasRaisedInvestment')
                  if (v === 'false') {
                    handleChange('', 'investmentAmount')
                    handleChange('', 'investmentOrigin')
                  }
                  isEmptyField(userConfigFormState.hasRaisedInvestment)
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => isEmptyField(userConfigFormState.hasRaisedInvestment)}
              >
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </Form.Select>
            </Col>

            {userConfigFormState.hasRaisedInvestment?.value === 'true' && companyType !== 'Admin City Hall' && companyType !== 'City Hall' && (
              <>
                {/* Quanto? */}
                <Col sm={6}>
                  <DescriptedLabel>
                    <strong>Quanto?<span style={{ color: 'red' }}> *</span></strong>
                  </DescriptedLabel>
                  <Input
                    type='number'
                    value={userConfigFormState.investmentAmount?.value}
                    isRequired={userConfigFormState.investmentAmount?.isRequired}
                    isInvalid={userConfigFormState.investmentAmount?.isInvalid}
                    notValidFieldMessage={userConfigFormState.investmentAmount?.message}
                    placeholder="Insira quanto de investimento captado"
                    onChange={e => {
                      handleChange(e.target.value, 'investmentAmount')
                      isEmptyField(userConfigFormState.investmentAmount)
                      store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                    }}
                  />
                </Col>

                {/* Origem do investimento */}
                <Col sm={6}>
                  <DescriptedLabel>
                    <strong>Qual a origem do investimento?<span style={{ color: 'red' }}> *</span></strong>
                  </DescriptedLabel>
                  <Form.Select
                    value={selectValue}
                    isInvalid={userConfigFormState.investmentOrigin?.isInvalid}
                    onChange={e => {
                      const v = e.target.value
                      if (v === 'Outro') {
                        setIsOtherOrigin(true)
                      } else {
                        setIsOtherOrigin(false)
                        store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                      }
                      handleChange(v, 'investmentOrigin')
                    }}
                    onBlur={() => isEmptyField(userConfigFormState.investmentOrigin)}
                  >
                    {RESOLVER_INVESTMENTE_SOURCE.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Select>
                </Col>

                {/* Outra origem */}
                {isOtherOrigin && (
                  <Col sm={6}>
                    <DescriptedLabel>
                      <strong>Qual outra origem do investimento?<span style={{ color: 'red' }}> *</span></strong>
                    </DescriptedLabel>
                    <Input
                      value={
                        userConfigFormState.investmentOrigin.value === 'Outro'
                          ? ''
                          : (userConfigFormState.investmentOtherOrigin.value === ''
                              ? userConfigFormState.investmentOrigin.value
                              : userConfigFormState.investmentOtherOrigin.value)
                      }
                      isRequired={userConfigFormState.investmentOtherOrigin?.isRequired}
                      isInvalid={userConfigFormState.investmentOtherOrigin?.isInvalid}
                      notValidFieldMessage={userConfigFormState.investmentOtherOrigin?.message}
                      placeholder="Insira outra origem"
                      onChange={e => {
                        const txt = e.target.value
                        isEmptyField(userConfigFormState.investmentOtherOrigin)
                        handleChange(txt, 'investmentOtherOrigin')
                        if (txt === '') { return }
                        handleChange(txt, 'investmentOrigin')
                        store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                      }}
                    />
                  </Col>
                )}
              </>
            )}
          </>
        )}

        {/* Campos específicos para funcionários da Caixa */}
        {isCaixaEmployee && companyType !== 'Admin City Hall' && companyType !== 'City Hall' && (
          <>
            {/* Cabeçalho com borda cinza */}
            <Col sm={12} style={{ margin: '40px 0 20px' }}>
              <div style={{ 
                borderTop: '1px solid #C4C5C6', 
                paddingTop: '16px',
                marginBottom: '20px'
              }}>
                <h6 style={{ 
                  color: '#6B7280', 
                  fontSize: '14px', 
                  fontWeight: '500',
                  margin: 0,
                  padding: 0
                }}>
                  Sobre o perfil do colaborador
                </h6>
              </div>
            </Col>
            {/* Cargo/Função */}
            <Col sm={6} style={{ margin: '0 0 20px' }}>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
                {labels.caixaRole} <span style={{ color: 'red' }}>*</span>
              </label>
              <Input
                id='caixaRole'
                value={userConfigFormState.caixaRole?.value || ''}
                isRequired={userConfigFormState.caixaRole?.isRequired}
                title={applyTitleOnError(userConfigFormState.caixaRole?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.caixaRole?.isInvalid}
                notValidFieldMessage={userConfigFormState.caixaRole?.message}
                placeholder={labels.caixaRolePlaceholder}
                onChange={(event) => {
                  handleChange(event.target.value, 'caixaRole')
                  if (userConfigFormState.caixaRole) {
                    isEmptyField(userConfigFormState.caixaRole)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => {
                  if (userConfigFormState.caixaRole) {
                    isEmptyField(userConfigFormState.caixaRole)
                  }
                }}
              />
            </Col>
            
            {/* Código da Unidade */}
            <Col sm={6} style={{ margin: '0 0 20px' }}>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
                {labels.caixaDepartment} <span style={{ color: 'red' }}>*</span>
              </label>
              <Input
                id='caixaDepartment'
                value={userConfigFormState.caixaDepartment?.value || ''}
                isRequired={userConfigFormState.caixaDepartment?.isRequired}
                title={applyTitleOnError(userConfigFormState.caixaDepartment?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.caixaDepartment?.isInvalid}
                notValidFieldMessage={userConfigFormState.caixaDepartment?.message}
                placeholder={labels.caixaDepartmentPlaceholder}
                onChange={(event) => {
                  handleChange(event.target.value, 'caixaDepartment')
                  if (userConfigFormState.caixaDepartment) {
                    isEmptyField(userConfigFormState.caixaDepartment)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => {
                  if (userConfigFormState.caixaDepartment) {
                    isEmptyField(userConfigFormState.caixaDepartment)
                  }
                }}
              />
            </Col>
            
            {/* Matrícula */}
            {/* <Col sm={6} style={{ margin: '0 0 20px' }}>
              <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
                {labels.caixaMatricula} <span style={{ color: 'red' }}>*</span>
              </label>
              <Input
                id='caixaMatricula'
                maxLength={6}
                isRequired={userConfigFormState.caixaMatricula?.isRequired}
                title={applyTitleOnError(userConfigFormState.caixaMatricula?.message || '', labels.titleMessage)}
                isInvalid={userConfigFormState.caixaMatricula?.isInvalid}
                notValidFieldMessage={userConfigFormState.caixaMatricula?.message}
                placeholder={labels.caixaMatriculaPlaceholder}
                value={userConfigFormState.caixaMatricula?.value || ''}
                onChange={(event) => {
                  // Remove todos os caracteres que não são números
                  const numericValue = event.target.value.replace(/[^0-9]/g, '')
                  handleChange(numericValue, 'caixaMatricula')
                  if (userConfigFormState.caixaMatricula) {
                    isEmptyField(userConfigFormState.caixaMatricula)
                  }
                  store.dispatch(updateConfigForm(handleUserConfigFormValidity(userConfigFormState, isResolver)))
                }}
                onBlur={() => {
                  if (userConfigFormState.caixaMatricula) {
                    isEmptyField(userConfigFormState.caixaMatricula)
                  }
                }}
              />
            </Col> */}
            
          </>
        )}
        </Row>
        </div>
    </>
  )
}